import React from 'react';
import { GenericSelect, GenericOption } from 'com-gyf-webcore-userinterfacecomponents';

const VinculacionDropdown = ({ cuentas, cambiarCuentaPrincipal, data, cuentasSeleccionadas, noMuestraSeleccionVinculos }) => {

    let contador = 0;
    for (var i = 0; i < cuentasSeleccionadas.length; i++) {
        if (cuentasSeleccionadas[i].checked) {

            contador += 1;
        }
    }

    if (contador < 2)
        return null;

    if (noMuestraSeleccionVinculos)
        return null;

    let cuentasResult;

    if (cuentasSeleccionadas !== undefined) {

        let json_string = JSON.stringify(cuentasSeleccionadas);
        let cuentasSeleccionadasDuplica = JSON.parse(json_string)
        cuentasSeleccionadasDuplica.unshift({
            numero: -1,
            id: -1,
            description: "Seleccione..."
        });

        cuentasResult = cuentasSeleccionadasDuplica.map((cuenta) => {
            if (cuenta.numero == -1) {
                return (
                    <GenericOption key={-1} id={-1} description={"Seleccione..."} />
                )
            } else {
                if (cuenta.checked)
                    return (
                        <GenericOption key={cuenta.numero} id={cuenta.numero} description={cuenta.tipo + " " + cuenta.numero} />
                    )
            }
        })
    }

    return (
        <div className="SeleccionCuenta">
            <p>Cuenta principal para esta tarjeta</p>
            <div className="CuentaSeleccionContainer">
                <span>
                    <GenericSelect
                        id="selectCuentasPrincipalEnSeleccionVinculo"
                        className="form-control default-select"
                        options={cuentasResult}
                        value={data.cuentasSeleccionadas}
                        onChange={(e) => cambiarCuentaPrincipal(e)}
                    />
                </span>
            </div>
        </div>
    );
}

export default VinculacionDropdown;
